// _shared/components/EventCountdown.jsx
import React from 'react';
import { useCountdown } from '../hooks/useEventCountdown';

const EventCountdown = ({ endDate, loading = false, variant = 'pc' }) => {
  // 🔥 Este es el ÚNICO hook que tickea. Solo ESTE componente se re-renderiza cada segundo.
  const countdown = useCountdown(endDate);
  const isPC = variant === 'pc';

  // Estado: cargando
  if (loading) {
    return (
      <div className={isPC ? 'pc-countdown-loading' : 'movil-countdown-loading'}>
        {isPC ? 'Cargando cuenta regresiva...' : 'Cargando...'}
      </div>
    );
  }

  // Estado: sin fecha
  if (!countdown || countdown.noDate) {
    return (
      <div className={isPC ? 'pc-countdown-loading' : 'movil-countdown-loading'}>
        {isPC ? 'No hay fecha del evento' : 'Fecha por confirmar'}
      </div>
    );
  }

  // Estado: evento iniciado
  if (countdown.expired) {
    return (
      <div className={isPC ? 'pc-countdown-expired' : 'movil-countdown-expired'}>
        {isPC ? '¡El evento ya comenzó!' : '¡Evento comenzó!'}
      </div>
    );
  }

  const bloques = [
    { valor: countdown.days, label: 'Días' },
    { valor: countdown.hours, label: 'Horas' },
    { valor: countdown.minutes, label: 'Min' },
    { valor: countdown.seconds, label: 'Seg' },
  ];

  // Variante PC
  if (isPC) {
    return (
      <div className="pc-countdown">
        {bloques.map((b) => (
          <div key={b.label} className="pc-countdown-item">
            <span className="pc-countdown-number">{String(b.valor).padStart(2, '0')}</span>
            <span className="pc-countdown-label">{b.label}</span>
          </div>
        ))}
      </div>
    );
  }

  // Variante Móvil
  return (
    <div className="movil-countdown-grid">
      {bloques.map((b) => (
        <div key={b.label} className="movil-countdown-item">
          <span className="movil-countdown-number">{String(b.valor).padStart(2, '0')}</span>
          <span className="movil-countdown-text">{b.label}</span>
        </div>
      ))}
    </div>
  );
};

export default EventCountdown;